import { createRouter, parseSearchWith, stringifySearchWith } from "@tanstack/react-router";
import { routeTree } from "src/routeTree.gen.ts";
import { PageNotFound } from "src/components/common/PageNotFound.tsx";
import { GeneratedViewListItem } from "src/routing/viewCatalog/viewCatalog.ts";

export const router = createRouter({
	routeTree,
	defaultNotFoundComponent: PageNotFound,
	// Render errors reach the app's Sentry error boundary, which reports them and shows the localized fallback.
	disableGlobalCatchBoundary: true,
	// Search values stay as the strings in the URL. The default serializer converts JSON-like values, such as "1e5",
	// and rewrites the URL to its canonical form, which would alter parameters that pages pass on, such as OAuth codes.
	parseSearch: parseSearchWith((value) => value),
	stringifySearch: stringifySearchWith(JSON.stringify),
});

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}

	interface StaticDataRouteOption {
		/** Title of a static view, shown in the main menu and the app bar. */
		title?: string;
		/**
		 * Key of the view in `StartUpData.frontendViews`, which decides whether the user can open it.
		 * Routes with a view key are main menu views and are kept alive while the user switches between them.
		 */
		legacyViewKey?: string;
		/** Lists the views of a param route, each of which gets its own main menu item. */
		listGeneratedViews?: () => Promise<GeneratedViewListItem[]>;
	}
}
